import React, { Component } from 'react'
import {Grid,Cell} from 'react-mdl'
export default class Landing extends Component {
  render() {
    return (
      <div style={{width :'100%',margin : 'auto'}}>
  <Grid className="landing-grid">
  <Cell col={12}>
  <img src="https://cdn.iconscout.com/icon/free/png-256/avatar-380-456332.png"
  alt="avatar"
  className="avatar-img">
  </img>
  <div className="banner-text">

  <h1>Full Stack Web Developer</h1>
  <hr/>
<p>HTML/CSS | Bootstrap | JavaScript | React | NodeJS | MongoDB</p>
  <div className="social-links">

  <a href="www.google.com" rel="noopener noreferrer" target="_blank">
  <i className="fa fa-linkedin-square"  aria-hidden="true"/>
  </a>

  <a href="www.google.com" rel="noopener noreferrer" target="_blank">
  <i className="fa fa-github-square"  aria-hidden="true"/>
  </a>
  <a href="www.google.com" rel="noopener noreferrer" target="_blank">
  <i className="fa fa-free-code-camp"  aria-hidden="true"/>
  </a>
  <a href="www.google.com" rel="noopener noreferrer" target="_blank">
  <i className="fa fa-youtube-square"  aria-hidden="true"/>
  </a>

  </div>
  </div>
  </Cell>
  </Grid>
      </div>
    )
  }
}
